<template>
  <div class="px-10">
    <div>
      {{ $route.path }}
    </div>
    <div class="md:flex">
      <div class="md:pt-10 md:w-48 md:border-r border-gray-500 md:pr-4">
        <div v-for="(item, i) in side" :key="i">
          <v-expansion-panels
            v-if="item.show"
            class="my-1"
            style="shadow:none;"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ item.title }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-for="(subitem, y) in item.child" :key="y">
                  {{ subitem.title }}
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div v-else>
            <v-btn class="w-full my-1" style="height:48px;" color="white">
              {{ item.title }}
            </v-btn>
          </div>
        </div>

        <!-- ==================== -->
      </div>
      <div>
        <div class="flex just justify-end">
          <div>
            <v-text-field
              label="Search"
              v-model="search"
              prepend-icon="mdi-magnify"
            ></v-text-field>
          </div>
        </div>
        <v-data-table :headers="headers" :items="items" :search="search">
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon @click="move(item)">
              mdi-send-outline
            </v-icon>
            <v-icon @click="email(item)">
              mdi-email
            </v-icon>
          </template>
        </v-data-table>
      </div>
    </div>
    <v-dialog
      v-model="dialog_move"
      persistent
      width="650px"
      :overlay="false"
      transition="dialog-transition"
    >
      <div class="bg-white p-2"><Move /></div>
    </v-dialog>
    <v-dialog
      v-model="dialog_email"
      persistent
      width="250px"
      :overlay="false"
      transition="dialog-transition"
    >
      <div class="bg-white p-2">
        <div class="flex justify-end">
          <v-icon @click="dialog_email = false">mdi-close</v-icon>
        </div>
        <div class="p-2">
          <Email />
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import Move from "./Move.vue";
import Email from "./Email.vue";
export default {
  components: {
    Move,
    Email,
  },
  data() {
    return {
      dialog_move: false,
      dialog_email: false,
      side: [
        {
          title: "New",
          value: 1,
          id: 1,
          show: false,
        },
        {
          title: "Updated BIS",
          value: 2,
          id: 2,
          show: true,
          child: [
            {
              title: "North",
            },
            {
              title: "South",
            },
            {
              title: "Vertical",
            },
          ],
        },
        {
          title: "Upload Request",
          value: 3,
          id: 3,
          show: false,
        },
        {
          title: "Moved",
          value: 4,
          id: 4,
          show: false,
        },
        {
          title: "Account Management",
          value: 5,
          id: 5,
          show: true,
          child: [
            {
              title: "North",
            },
            {
              title: "South",
            },
            {
              title: "Vertical",
            },
          ],
        },
        {
          title: "Receivables",
          value: 6,
          id: 6,
          show: true,
          child: [
            {
              title: "Requests",
            },
            {
              title: "Proof of Payment",
            },
            {
              title: "Notices",
            },
            {
              title: "BIS",
            },
          ],
        },
        {
          title: "Mortgage",
          value: 7,
          id: 7,
          show: false,
        },
        {
          title: "After Sales",
          value: 8,
          id: 8,
          show: true,
          child: [
            {
              title: "North",
            },
            {
              title: "South",
            },
            {
              title: "Vertical",
            },
          ],
        },
        {
          title: "Records",
          value: 9,
          id: 9,
          show: true,
          child: [
            {
              title: "RPT",
            },
            {
              title: "Documents",
            },
            {
              title: "Official Receipt",
            },
            {
              title: "Title TD",
            },
          ],
        },
        {
          title: "Closed",
          value: 10,
          id: 10,
          show: false,
        },
      ],
      search: "",
      headers: [
        {
          text: "Date Submitted",
          value: "date_submitted",
        },
        {
          text: "Principal Buyer",
          value: "date_submitted",
        },
        {
          text: "Project",
          value: "date_submitted",
        },
        {
          text: "Classification",
          value: "date_submitted",
        },
        {
          text: "Subject",
          value: "date_submitted",
        },
        {
          text: "Contract No.",
          value: "date_submitted",
        },
        {
          text: "Financing",
          value: "date_submitted",
        },
        {
          text: "Status",
          value: "date_submitted",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
      items: [
        {
          date_submitted: "1/1/2000",
        },
      ],
    };
  },
  methods: {
    move() {
      this.dialog_move = true;
    },
    email() {
      this.dialog_email = true;
    },
  },
};
</script>
